// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A special switch definition within a catalog.
 */
export class SpecialDefinition implements flatbuffers.IUnpackableObject<SpecialDefinitionT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SpecialDefinition {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSpecialDefinition(
    bb: flatbuffers.ByteBuffer,
    obj?: SpecialDefinition,
  ): SpecialDefinition {
    return (obj || new SpecialDefinition()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSpecialDefinition(
    bb: flatbuffers.ByteBuffer,
    obj?: SpecialDefinition,
  ): SpecialDefinition {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SpecialDefinition()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  specialCatalogId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  message(): string | null;
  message(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  message(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  shortMessage(): string | null;
  shortMessage(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  shortMessage(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  bit(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  byte(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startSpecialDefinition(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addSpecialCatalogId(
    builder: flatbuffers.Builder,
    specialCatalogIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(1, specialCatalogIdOffset, 0);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, messageOffset, 0);
  }

  static addShortMessage(builder: flatbuffers.Builder, shortMessageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, shortMessageOffset, 0);
  }

  static addBit(builder: flatbuffers.Builder, bit: number) {
    builder.addFieldInt32(4, bit, 0);
  }

  static addByte(builder: flatbuffers.Builder, byte: number) {
    builder.addFieldInt32(5, byte, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, deletedAtOffset, 0);
  }

  static endSpecialDefinition(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): SpecialDefinitionT {
    return new SpecialDefinitionT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.specialCatalogId() !== null ? this.specialCatalogId()!.unpack() : null,
      this.message(),
      this.shortMessage(),
      this.bit(),
      this.byte(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: SpecialDefinitionT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.specialCatalogId =
      this.specialCatalogId() !== null ? this.specialCatalogId()!.unpack() : null;
    _o.message = this.message();
    _o.shortMessage = this.shortMessage();
    _o.bit = this.bit();
    _o.byte = this.byte();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): SpecialDefinitionT {
    const t = new SpecialDefinitionT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("special_catalog_id")) {
      t.specialCatalogId =
        this.specialCatalogId() !== null ? this.specialCatalogId()!.unpack() : null;
    }
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    if (fieldSet.has("short_message")) {
      t.shortMessage = this.shortMessage();
    }
    if (fieldSet.has("bit")) {
      t.bit = this.bit();
    }
    if (fieldSet.has("byte")) {
      t.byte = this.byte();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class SpecialDefinitionT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public specialCatalogId: UuidT | null = null,
    public message: string | Uint8Array | null = null,
    public shortMessage: string | Uint8Array | null = null,
    public bit: number = 0,
    public byte: number = 0,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const specialCatalogId =
      this.specialCatalogId !== null ? this.specialCatalogId!.pack(builder) : 0;
    const message = this.message !== null ? builder.createString(this.message!) : 0;
    const shortMessage = this.shortMessage !== null ? builder.createString(this.shortMessage!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    SpecialDefinition.startSpecialDefinition(builder);
    SpecialDefinition.addId(builder, id);
    SpecialDefinition.addSpecialCatalogId(builder, specialCatalogId);
    SpecialDefinition.addMessage(builder, message);
    SpecialDefinition.addShortMessage(builder, shortMessage);
    SpecialDefinition.addBit(builder, this.bit);
    SpecialDefinition.addByte(builder, this.byte);
    SpecialDefinition.addCreatedAt(builder, createdAt);
    SpecialDefinition.addUpdatedAt(builder, updatedAt);
    SpecialDefinition.addDeletedAt(builder, deletedAt);

    return SpecialDefinition.endSpecialDefinition(builder);
  }

  clone(): SpecialDefinitionT {
    const obj = new SpecialDefinitionT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.specialCatalogId = this.specialCatalogId !== null ? this.specialCatalogId!.clone() : null;
    obj.message = this.message;
    obj.shortMessage = this.shortMessage;
    obj.bit = this.bit;
    obj.byte = this.byte;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: SpecialDefinitionT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.specialCatalogId !== null && other.specialCatalogId !== null) {
      if (!this.specialCatalogId!.equals(other.specialCatalogId!)) return false;
    } else if (this.specialCatalogId !== other.specialCatalogId) return false;
    if (this.message !== other.message) return false;
    if (this.shortMessage !== other.shortMessage) return false;
    if (this.bit !== other.bit) return false;
    if (this.byte !== other.byte) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifySpecialDefinition(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
